/**
 * client/src/app/cognitive-route.ts
 *
 * Split out of `aal3-route-status.ts` for the 300-line modularity cap (review
 * round 1 of #3268) — self-contained: `resolveCognitiveRoute` takes no
 * arguments and reads nothing from the rest of that file.
 */

/** Whether the cognitive bank can currently grant Level 3, fresh. */
export type CognitiveRoute =
  /** Not readable right now — keep the existing neutral copy. */
  | "unknown"
  /** Server-side promotion is withheld from everyone — permanently, since the
   *  legacy cognitive-first promotion path is retired. */
  | "unavailable"
  /** Available, bank below the sufficiency baseline. */
  | "below-baseline"
  /** Available, bank at or above the baseline. */
  | "at-baseline";

/**
 * Pure counterpart for the cognitive route.
 *
 * ALWAYS `"unavailable"`, and deliberately not a read of anything. The server
 * withholds cognitive-first Level 3 promotion from every account, permanently
 * (`LEGACY_COGNITIVE_PROMOTION_DISABLED`, server/logic/seed-interview/
 * reconfirm.ts) — the OSINT-screening signal this used to consult was deleted
 * with that subsystem (2026-08-31 security tier ladder spec, module 06 R8), and
 * a bank at baseline still cannot promote. Reporting `"at-baseline"` here would
 * offer a route that cannot work, which is the exact dishonesty this module
 * exists to prevent. It stays a function (not a constant) so the one call site
 * keeps its shape, and so a future re-spec has one place to make it a live
 * read again. It used to accept a `_seeding` parameter it never read (a stub
 * left over from when this DID consult seeding progress) — removed as dead
 * code (fix-round minor #4); a future live read adds the parameter back when
 * it actually has something to read.
 */
export function resolveCognitiveRoute(): CognitiveRoute {
  return "unavailable";
}
